import variables from '../../stylesheets/variables.module.scss';
import {
    AgeSegmentRoomState,
    BookingState,
    CreditCardState,
} from '../../types/booking/BookingTypes';

export const gridColumnsSpacing = {
    xs: '30px',
    sm: '30px',
    lg: '30px',
    xl: '30px',
};

export const gridRowsSpacing = {
    xs: '20px',
    sm: '20px',
    lg: '20px',
    xl: '20px',
};

export const bookingFiltersSize = { xs: 12, sm: 6, md: 6, lg: 6, xl: 3 };
export const bookingDateFiltersSize = { xs: 12, sm: 6, md: 6, lg: 6, xl: 6 };
export const singleColumnGrid = { xs: 12, sm: 6, md: 6, lg: 6, xl: 3 };
export const doubleColumnGrid = { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 };
export const imageColumnGrid = { xs: 6, sm: 6, md: 3, lg: 3, xl: 3 };

export const avatarColumnGrid = { xs: 12, sm: 6, md: 12, lg: 6, xl: 3 };
export const creditCardColumnGrid = { xs: 6, sm: 6, md: 6, lg: 6, xl: 3 };

export const AGE_SEGMENT_COLOR = {
    [AgeSegmentRoomState.ADULT]: variables.accentColorPurple400,
    [AgeSegmentRoomState.CHILD]: variables.accentColorOrange400,
    [AgeSegmentRoomState.BABY]: variables.accentColorCyan400,
};

export const OTA_REFERENCE_TABLE_CODE_KEY = '10';

export const detailBookingInitialState: BookingState = {
    status: '',
    statusColor: '',
    hotel: '',
    hotelImages: [],
    address: '',
    hotelRating: 0,
    hotelCategory: '',
    bookingCode: '',
    hotelRefecerenceCode: '',
    checkIn: null,
    checkOut: null,
    bookingDate: null,
    nights: 0,
    paxes: 0,
    customerName: '',
    totalAmount: 0,
    paymentId: 0,
    currency: '',
    notes: '',
    cancellationPolicies: [],
    rooms: [],
    prices: [],
};

export const creditCardInitialState: CreditCardState = {
    creditCardHolderName: '',
    creditCardNumber: '',
    creditCardExpiryDate: '',
    cvc: '',
};

export const EMPTY_CREDIT_CARD_NUMBER = 'XXXXXXXXXXXXXXXX';

export const EMPTY_CREDIT_CARD_HOLDER_NAME = 'FASTPAY HOTELS';
export const EMPTY_CREDIT_CARD_EXPIRE_DATE = '--/--';
